module.exports = __webpack_public_path__ + "assets/2dbfe71131053d28fb0d407f8857cd9d.mp3";